import Filter from './Filter';
import $ from 'jquery';

// Dropdown filter
export default class DropdownFilter extends Filter {

  constructor($element, options) {
    super($element, options);
    if ($element.length === 0) return false;

    this.filterType = "DropdownFilter";
    this.emptyValue = 0;

   
    this.$select = this.getElement().selectize({
      onChange: this.onChange.bind(this),
      onFocus: this.onFocus.bind(this),
      dropdownParent: 'body'
    });

    this.instance = this.$select[0].selectize
  }

  getValue() {
    let value = this.getElement().val();
    return (!value || value == "0") ? false : value;
  }

  setValue(values) {
    if( !values ) values = [this.emptyValue];

    if( typeof values == "string" ) {
      values = values.split(/\s|\+/);
    }
    this.blockEvent = true;
    this.getElement().get(0).selectize.setValue(values[0]);
  }

  getKey() {
    return this.getElement().attr('name');
  }

  getElement() {
    return this.$element.find('.dropdown-filter');
  }

  onChange(val) {
  
    if (this.blockEvent) {
      this.blockEvent = false;
      return;
    }
    
    $.messages.send({
      type: 'FILTER/VALUE_CHANGED',
      key: this.getKey(),
      value: val,
      sender: this
    });

    this.blockEvent = true;
    this.instance.setValue(val);
  }

  onFocus() {
    this.blockEvent = true;
    this.instance.clear();
    this.blockEvent = false;
  }
}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/DropdownFilter.js
 **/